class PurchaseOrderModalController extends AbstractController
	@register()
	@inject '$uibModalInstance',
		'$state'
		'copyPurchaseOrder'
		'stockLocations'
		'shops'
		'suppliers'
		'filter'
		'productsList'
		'PurchaseOrderService'
		'PurchaseOrderFormatService'
		'DATE_FORMAT'
		'PURCHASE_ORDER'
		'UserInformation'
		'ToastService'
		'MessageTypes'
		'translate'

	initialize: ->
		@deliveryTypes = @PurchaseOrderService.getDeliveryTypes()
		@filter ?= {}

		@initPurchaseOrder()

		@shopData = _.groupBy(@shops, 'stock_location_id')
		@shopsList = @shopData[@purchaseOrder.stock_location_id] ? []

		@purchaseOrderStockLocation = _.find(@stockLocations, {id: @purchaseOrder.stock_location_id})
		@purchaseOrderShop = _.find(@shopsList, {id: @purchaseOrder.shop_id})
		@purchaseOrderSupplier = _.find(@suppliers, {id: @purchaseOrder.supplier_id})


		@datePickerInfo =
			singleDatePicker: true
			startDate: moment.unix(@purchaseOrder.expected_delivery_time)
			minDate: moment()

		@setName(@copyPurchaseOrder.is_new || @purchaseOrder.name == @getName())
		@setEmail(@copyPurchaseOrder.is_new || @purchaseOrder.name == @getName())
		@setLineItems()
		@setTotals()

	initPurchaseOrder: ->
		if @copyPurchaseOrder.is_new
			@purchaseOrder =
				name: null
				email: null
				stock_location_id: @filter.stockLocationId
				shop_id: @filter.shopId
				supplier_id: @filter.supplierId
				expected_delivery_time: @filter.endTime
				line_items: []
				delivery_type: if @filter.shopId? then @PURCHASE_ORDER.DELIVERY_TYPE.SHOP else @PURCHASE_ORDER.DELIVERY_TYPE.STOCK_LOCATION
				status: @PURCHASE_ORDER.STATUS.ACTIVE
		else
			@purchaseOrder = angular.copy @copyPurchaseOrder
			@purchaseOrder.id = null
			@purchaseOrder.status = @PURCHASE_ORDER.STATUS.ACTIVE

		if !_.isEmpty(@purchaseOrder.line_items)
			for item in @purchaseOrder.line_items
				item.id = null
				item.requested_quantity = parseFloat(item.requested_quantity)

			@productsList = @PurchaseOrderFormatService.purchaseOrderToReport @purchaseOrder

	setTotals: ->
		@totalRequestedQuantity = 0
		@totalCostPrice = 0

		for item in @purchaseOrder.line_items
			@totalRequestedQuantity += item.requested_quantity
			@totalCostPrice += item.requested_quantity * item.cost_price

	onEndTimeChange: (endDateTimestamp) ->
		@purchaseOrder.expected_delivery_time = endDateTimestamp
		@setName()

	save: ->
		if @purchaseOrderForm.$invalid
			return

		@saving = true

		@PurchaseOrderService
			.save @purchaseOrder
			.then (response) =>
				@ToastService.add(
					response.data.name,
					@translate('general.purchase_order'),
					@translate(if !@copyPurchaseOrder.is_new then 'general.copy' else 'alert.saved'),
					'success'
				)

				@$uibModalInstance.close(true)
				@$state.go 'purchase_order.edit.details', {id: response.data.id}

				if @$state.is 'purchase_order.edit.details'
					@MessageTerminal.afterSave true, response.data
			.catch (response) =>
				@ToastService.showErrors response, @translate('general.purchase_order')
			.finally =>
				@saving = false

	setLineItems: ->
		if !@productsList?
			return

		for products in @productsList
			for product in products
				if not product.virtual and product.selected and product.requested_quantity > 0
					product.received_quantity = null
					@purchaseOrder.line_items.push product

	getSupplierId: ->
		if not _.isEmpty(@purchaseOrder.supplier_id)
			return @purchaseOrder.supplier_id
		else if not _.isEmpty(@filter.supplierId)
			return @filter.supplierId

		return null

	setEmail: (forceChange = false) ->
		if not forceChange and @previousEmail != @purchaseOrder.email
			return

		@purchaseOrder.email = _.find(@suppliers, {id: @filter.supplierId})?.email if not _.isEmpty(@filter.supplierId)
		@purchaseOrder.email = _.find(@suppliers, {id: @purchaseOrder.supplier_id})?.email if not  _.isEmpty(@purchaseOrder.supplier_id)
		@previousEmail = @purchaseOrder.email

	setName: (forceChange = false) ->
		if not forceChange and @previousName != @purchaseOrder.name
			return

		@purchaseOrder.name = @getName()
		@previousName = @purchaseOrder.name

	getName: ->
		name = @UserInformation.getMasterUser().company_name
		supplierId = @getSupplierId()

		if supplierId?
			name += '; ' + @translate('general.supplier') + ': ' + _.find(@suppliers, {id: supplierId}).name

		name += ' - ' + @datePickerInfo.startDate.clone().format(@DATE_FORMAT)
		name = name.substring(0, 255)

		return name

	onRequestedQuantityChange: () ->
		@setTotals()

	onStockLocationChange: ->
		@purchaseOrder.shop_id = null
		@shopsList = @shopData[@purchaseOrder.stock_location_id] ? []
		@purchaseOrder.delivery_type = @PURCHASE_ORDER.DELIVERY_TYPE.STOCK_LOCATION

		if !_.isEmpty(@shopsList)
			@purchaseOrder.shop_id = _.first(@shopsList).id
			@purchaseOrder.delivery_type = @PURCHASE_ORDER.DELIVERY_TYPE.SHOP

	onShopChange: ->
		if @purchaseOrder.shop_id?
			@purchaseOrder.delivery_type = @PURCHASE_ORDER.DELIVERY_TYPE.SHOP

			return

		@purchaseOrder.delivery_type = @PURCHASE_ORDER.DELIVERY_TYPE.STOCK_LOCATION

